import React from 'react';
import FormModal from '../../../components/ui/FormModal/FormModal';
import { PROJECT_FORM_FIELDS, cleanProjectValues } from './projectFormFields';

/**
 * Edit Project modal — uses the shared FormModal primitive + the
 * shared project field schema (projectFormFields.js). Symmetric with
 * CreateProjectModal: identical fields, validation, and cleanup; the
 * only differences are title, submit-label wording, initialValues
 * sourced from the existing `project` prop, and the onSave signature
 * (passes session_id + cleaned values to the parent handler).
 */
const EditProjectModal = ({ project, onClose, onSave }) => (
  <FormModal
    title="Edit Project"
    fields={PROJECT_FORM_FIELDS}
    initialValues={{
      analysis_name: project.analysis_name ?? '',
      company_name: project.company_name ?? '',
      company_type: project.company_type ?? 'OEM',
      company_type_other: project.company_type_other ?? '',
      attack_feasibility_approach:
        project.attack_feasibility_approach ?? 'Attack Potential',
      tara_level: project.tara_level ?? 'component',
    }}
    submitLabel="Save Changes"
    submittingLabel="Saving..."
    maxWidth={560}
    onSubmit={async (values) => {
      await onSave(project.session_id, cleanProjectValues(values));
    }}
    onClose={onClose}
  />
);

export default EditProjectModal;
